// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-preview[data-v-6f869f74]{position:absolute;left:0;right:0;top:45px;margin-left:auto;margin-right:auto;width:var(--value)}.product-preview__img[data-v-6f869f74]{position:absolute;top:0;left:0;max-height:var(--value);max-width:var(--value)}.product-preview__img[data-v-6f869f74]:hover{cursor:pointer}.product-preview__img-shape[data-v-6f869f74]{position:absolute}", ""]);
// Exports
module.exports = exports;
